import {A} from 'components/atoms/LinksAndButtons/A';
import {LinkStyle} from 'features/ui/enums';

import {AsyncImage} from 'components/atoms/Media/AsyncImage';
import {ResidenceTags} from 'components/atoms/Tags/ResidenceTags';

import 'components/molecules/ResidentialCards/ResidenceCardsOld/style.scss';
import {ObjectSuggestion} from 'components/molecules/SuggestionCards/ObjectSuggestion';

import {StageSuggestion} from 'components/molecules/SuggestionCards/StageSuggestion';

import {ImageSizes} from 'components/organisms/Shell/image-size-enum';
import * as React from 'react';
import {getCardUrl, isNotChildSite} from 'features/services/utils/url-helper';

import './style.scss';
import {SearchResult} from "features/search/types";
import {useEffect} from "react";

interface Props {
    residence: SearchResult;
    hideArrow?: boolean;
    image?: string;
    collapsible?: boolean;
    forceVisibility?: boolean;
}

export const VerticalResidenceCard: React.FunctionComponent<Props> = ({residence, hideArrow, image, collapsible: _collapsible, forceVisibility: _forceVisibility}) => {
    const url = getCardUrl(residence);
    const childSite = isNotChildSite(residence.siteId);

    const [_imageLoaded, setImageLoaded] = React.useState(false);

    useEffect(() => {
        // Haxx, image dosent load correctly in modal, it needs a state render.
        if(image) {
            setImageLoaded(true);
        }
        return () => {
            setImageLoaded(false);
        }
    }, [image]);

    return (
        <A
            href={url}
            className="residence-block residence-block--no-hover vertical-residence-card"
            variant={LinkStyle.UNSTYLED}
            route={childSite}
            target={
                childSite ?
                    '' :
                    '_blank'
            }
            title=''
        >
            <div className="residence-block__image vertical-residence-card__image-container">
                <ResidenceTags
                    stageStatus={
                        residence.type === 'stage' ?
                            residence.stageStatus.toString() :
                            ''
                    }
                    objectStatus={
                        residence.type === 'object' ?
                            residence.objectStatus.toString() :
                            ''
                    }
                    concept={residence.concept.toString()}
                    siteId={residence.siteId}
                />
                <AsyncImage
                    quality={ImageSizes.SIZE_600}
                    src={image ? image : ""}
                    fullHeight
                    alt="bild"
                    noCrop
                    forceVisibility
                />
            </div>

            <div className="residence-block__content vertical-residence-card__content">
                {residence.type === "object" && <ObjectSuggestion object={residence} hideArrow={hideArrow} />}
                {residence.type === "stage" && <StageSuggestion stage={residence} />}
            </div>
        </A>
    )
};
